import { useEffect } from 'react';

import { isLogFeatureGateExposureMessage } from '@rovo-extension/feature-gates-adapter';

import { extensionUrl } from '../config/config';
import { manuallyLogExposureSafely } from '../experiment/experimentClient';

/**
 * Relays an experiment's exposure from the extension into the live SDK client: a chrome-layer
 * experiment, or one the frontend owns and the extension relays. Fire-and-forget, no ack.
 * Origin check copied from `useChatBridgeAPI`. Mount once — this listens on `window`, so a second
 * instance would double-log the same exposure.
 */
export function useFeatureGateExposureRelay(): void {
	useEffect(() => {
		const handler = (event: MessageEvent): void => {
			if (event.origin !== extensionUrl || event.source !== window.parent) {
				return;
			}
			if (!isLogFeatureGateExposureMessage(event.data)) {
				return;
			}

			const { key } = event.data;
			manuallyLogExposureSafely(key);
		};

		window.addEventListener('message', handler);
		return (): void => window.removeEventListener('message', handler);
	}, []);
}
